import React from 'react';

export function FlexBoxDummies(className: string, count: number) {
  return Array(count)
    .fill(undefined)
    .map((v, i) => <div className={`${className} dummy`} key={'dummy-' + i} />);
}
